import React, { useRef } from 'react';
import { useGLTF } from '@react-three/drei';
import * as global from "../../data/global";

export function AnDash(props) {
    const group = useRef();
    const { nodes } = useGLTF('3ds/an/AnDash.gltf');
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (!global.gw.geometries.AnDash) {
                        global.gw.geometries.AnDash = e.geometry;
                    }
                }}
                name="AnDash"
                geometry={nodes.AnDash.geometry}
                position={[0, 3, 0]}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/AnDash.gltf')
